import { render, staticRenderFns } from "./RiskProfileBox.vue?vue&type=template&id=5909c25c&"
import script from "./RiskProfileBox.vue?vue&type=script&lang=ts&"
export * from "./RiskProfileBox.vue?vue&type=script&lang=ts&"
import style0 from "./RiskProfileBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports